export function isAuthRequiredResponse(status, data) {
  const errorText = String(data?.error || data?.message || "").toLowerCase();
  return status === 401 || status === 403 || errorText.includes("unauthorized") || errorText.includes("forbidden");
}

export function dispatchAdminAuthRequired() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("lpf-admin-auth-required"));
}

export async function adminFetchJson(url, options = {}) {
  const headers = {
    Accept: "application/json",
    ...(options.body ? { "Content-Type": "application/json" } : {}),
    ...(options.headers || {}),
  };

  const res = await fetch(url, {
    credentials: "same-origin",
    ...options,
    headers,
  });

  const text = await res.text();
  let data = null;

  if (text.trim()) {
    try {
      data = JSON.parse(text);
    } catch (_) {
      const err = new Error(`Expected JSON from ${url}, got: ${text.slice(0, 180)}`);
      err.status = res.status;
      err.responseText = text;
      throw err;
    }
  }

  if (isAuthRequiredResponse(res.status, data)) {
    const err = new Error("Authentication required. Please log in again.");
    err.authRequired = true;
    err.status = res.status;
    err.data = data;
    dispatchAdminAuthRequired();
    throw err;
  }

  if (!res.ok) {
    const err = new Error(data?.error || data?.detail || `Request failed with HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

export function normalizeArrayPayload(data, keys = []) {
  if (Array.isArray(data)) return data;
  for (const key of keys) {
    if (Array.isArray(data?.[key])) return data[key];
  }
  return [];
}
